var clamp = function (min, max) { return function (n) {
    if (n < min) {
        return min;
    }
    if (n > max) {
        return max;
    }
    return n;
}; };
export default clamp;
